import React, { useEffect, useState } from 'react';

// Renders an <img> whose source requires the Bearer token. Mirrors the training
// SlideViewer pattern: fetch as a blob with auth, then use an object URL.
export default function AuthImage({ url, alt = '', className, style }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    setSrc(null);
    setError(false);
    if (!url) return undefined;
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(url, { headers: { Authorization: token ? `Bearer ${token}` : '' } });
        if (!res.ok) throw new Error(`image ${res.status}`);
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (active) setSrc(objectUrl);
      } catch (_) {
        if (active) setError(true);
      }
    })();
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url]);

  if (error) {
    return <div className="text-xs text-rose-300/80">Image unavailable</div>;
  }
  if (!src) {
    return <div className="text-xs text-slate-500">Loading image…</div>;
  }
  return <img src={src} alt={alt} className={className} style={style} />;
}
